import { __ } from './Lang'

export function utcParaLocal(isoString) {
    if (isoString) {
        let match = isoString.match(/^(\d{4})-(\d{2})-(\d{2})$/)
        if (match) {
            return new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]))
        }
    }

    return new Date(isoString)
}

export function nomeDoDiaDaSemana(date) {
    return [
        __('Domingo'),
        __('Segunda-feira'),
        __('Terça-feira'),
        __('Quarta-feira'),
        __('Quinta-feira'),
        __('Sexta-feira'),
        __('Sábado'),
    ][date.getDay()]
}

export function nomeDoMês(date) {
    return [
        __('janeiro'),
        __('fevereiro'),
        __('março'),
        __('abril'),
        __('maio'),
        __('junho'),
        __('julho'),
        __('agosto'),
        __('setembro'),
        __('outubro'),
        __('novembro'),
        __('dezembro'),
    ][date.getMonth()]
}

export function formatarDataHoraUtc(date) {
    return (
        date.getUTCFullYear() +
        '-' +
        pad(date.getUTCMonth() + 1) +
        '-' +
        pad(date.getUTCDate()) +
        ' ' +
        pad(date.getUTCHours()) +
        ':' +
        pad(date.getUTCMinutes()) +
        ':' +
        pad(date.getUTCSeconds())
    )
}

export function formatarISO(date) {
    return (
        date.getUTCFullYear() +
        '-' +
        pad(date.getUTCMonth() + 1) +
        '-' +
        pad(date.getUTCDate()) +
        'T' +
        pad(date.getUTCHours()) +
        ':' +
        pad(date.getUTCMinutes()) +
        ':' +
        pad(date.getUTCSeconds()) +
        'Z'
    )
}

export function formatarDataUtc(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate())
}

export function formatarDataHora(date) {
    return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds())
    )
}

export function formatarDataHoraAmigável(date) {
    return (
        pad(date.getDate()) +
        '/' +
        pad(date.getMonth() + 1) +
        '/' +
        date.getFullYear() +
        ' ' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes())
    )
}

export function formatarDataAmigável(date) {
    return pad(date.getDate()) + '/' + pad(date.getMonth() + 1) + '/' + date.getFullYear()
}

export function formatarHoraAmigável(date) {
    return pad(date.getHours()) + ':' + pad(date.getMinutes())
}

export function formatarSegundosEmHHMMSS(timestamp) {
    let oneDayInSeconds = 86400
    if (timestamp > oneDayInSeconds) {
        let days = parseInt(timestamp / oneDayInSeconds)
        let restante = timestamp - days * oneDayInSeconds
        let horas = parseInt(restante / 3600)
        return `${days}d ${horas}h`
    }

    let horas = parseInt(timestamp / 3600)
    let restante = timestamp - horas * 3600
    let minutos = parseInt(restante / 60)
    restante = restante - minutos * 60
    let segundos = parseInt(restante)

    return pad(horas) + ':' + pad(minutos) + ':' + pad(segundos)
}

export function formatTimeOrDateMonth(date) {
    let now = new Date()
    if (
        now.getDate() == date.getDate() &&
        now.getMonth() == date.getMonth() &&
        now.getFullYear() == date.getFullYear()
    ) {
        return pad(date.getHours()) + ':' + pad(date.getMinutes())
    }

    return date.getDate() + ' ' + nomeDoMês(date)
}

export function pad(str) {
    str = str.toString()
    return str.length == 1 ? '0' + str : str
}
